export default class Environment {
  static setEnv(env) {
    window.env = env;
  }

  static getEnv() {
    return window.env;
  }
}

